// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectStaffButton_wrapper_1WR22"};